import Link from "next/link";
import { ButtonLink } from "@/components/Buttons";
import routes from "@/lib/routes";
import formatPrice from "@/lib/formatPrice";
import { useAdultModeQuery } from "@/hooks";
import ProcessInformation from "@/components/ProcessInformation";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { PAYMENT_METHOD_NAMES, COURSE_TRIAL_DURATION_UNIT } from "@/lib/constants";
import { useMemo } from "react";
import dayjs from "@/lib/day";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function SubscriptionFormStep3(_ref) {
  var _course$channel;

  var subscriptionData = _ref.subscriptionData,
      paymentMethod = _ref.paymentMethod,
      subscribeData = _ref.subscribeData;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useAdultModeQuery.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  var course = subscriptionData.course,
      subscriptionStatus = subscriptionData.subscriptionStatus,
      broadcastDiscount = subscriptionData.broadcastDiscount;
  var price = formatPrice((course === null || course === void 0 ? void 0 : course.price) || 0);
  var trialFlag = subscriptionStatus.is_trial_enabled;
  var broadcastDiscountFlag = useMemo(function () {
    var _course$active_pricin, _course$active_pricin2;

    // コースに適用されたキャンペーンのbroadcastDiscountフラグを参照して判定する
    var isBroadcastCampaign = course === null || course === void 0 ? void 0 : (_course$active_pricin = course.active_pricing) === null || _course$active_pricin === void 0 ? void 0 : (_course$active_pricin2 = _course$active_pricin.campaign) === null || _course$active_pricin2 === void 0 ? void 0 : _course$active_pricin2.broadcastDiscount;
    return isBroadcastCampaign && (broadcastDiscount === null || broadcastDiscount === void 0 ? void 0 : broadcastDiscount.result);
  }, [course, broadcastDiscount]);
  var broadcastDiscountPrice = formatPrice(course === null || course === void 0 ? void 0 : course.discount_price);

  var _subscribeData$subscr = subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.subscribe,
      initialTransactionAt = _subscribeData$subscr.initialTransactionAt,
      trialStartAt = _subscribeData$subscr.trialStartAt,
      trialEndAt = _subscribeData$subscr.trialEndAt;

  var trialTerm = useMemo(function () {
    if (trialFlag) {
      var s = dayjs(new Date(trialStartAt));
      var e = dayjs(new Date(trialEndAt));
      var _COURSE_TRIAL_DURATIO = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit],
          label = _COURSE_TRIAL_DURATIO.label,
          unit = _COURSE_TRIAL_DURATIO.unit;
      return "".concat(e.diff(s, unit)).concat(label);
    }
  }, [trialFlag, trialStartAt, trialEndAt]);
  var trialTermText = useMemo(function () {
    if (trialTerm) {
      return course !== null && course !== void 0 && course.trialCampaignFlag ? "".concat(trialTerm, "\u7121\u6599\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3") : "".concat(trialTerm, "\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB");
    }
  }, [course, trialTerm]);
  return /*#__PURE__*/_jsxs(ProcessInformation, {
    complete: true,
    header: "\u8CFC\u5165\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
    children: [trialFlag && /*#__PURE__*/_jsxs("div", {
      children: [trialTerm, "\u306E\u7121\u6599", course.trialCampaignFlag && "キャンペーン", "\u671F\u9593\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044"]
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.container, " ").concat(styles.center),
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(styles.section, " ").concat(styles.nopadding),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.sectionLeft,
          children: /*#__PURE__*/_jsx("img", {
            src: course.thumbnailUrl
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.sectionRight,
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles.title,
            children: course.name
          }), !trialFlag && !broadcastDiscountFlag && /*#__PURE__*/_jsxs("div", {
            className: "".concat(styles.info, " ").concat(styles.price),
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u91D1\u984D"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.right,
              children: [/*#__PURE__*/_jsxs("span", {
                className: styles.priceAmount,
                children: [price, "\u5186"]
              }), "\uFF08\u7A0E\u8FBC\uFF09\uFF0F\u6708"]
            })]
          }), trialFlag && !broadcastDiscountFlag && /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.info, " ").concat(styles.price, " ").concat(styles.trialPrice),
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.right,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.labelArea,
                children: [/*#__PURE__*/_jsx("span", {
                  className: styles.bold,
                  children: trialTermText
                }), /*#__PURE__*/_jsx("span", {
                  className: styles.period,
                  children: "".concat(trialEndAt, "\u307E\u3067")
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.precautions,
                children: "\u203B".concat(course.trialText, "\u7D42\u4E86\u6642\u306B\u6708\u984D").concat(price, "\u5186\uFF08\u7A0E\u8FBC\uFF09")
              })]
            })
          }), broadcastDiscountFlag && !trialFlag && /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "".concat(styles.info, " ").concat(styles.price),
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.left,
                children: "\u5272\u5F15\u91D1\u984D"
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.right,
                children: [/*#__PURE__*/_jsxs("span", {
                  className: styles.priceAmount,
                  children: [broadcastDiscountPrice, "\u5186"]
                }), "\uFF08\u7A0E\u8FBC\uFF09\uFF0F\u6708", /*#__PURE__*/_jsx("br", {})]
              })]
            })
          }), broadcastDiscountFlag && trialFlag && /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.info, " ").concat(styles.price, " ").concat(styles.trialPrice),
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.right,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.labelArea,
                children: [/*#__PURE__*/_jsx("span", {
                  className: styles.bold,
                  children: trialTermText
                }), /*#__PURE__*/_jsx("span", {
                  className: styles.period,
                  children: "".concat(trialEndAt, "\u307E\u3067")
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.precautions,
                children: ["\u203B".concat(course.trialText, "\u671F\u9593\u5F8C\u306F\u6708\u984D").concat(price, "\u5186\uFF08\u7A0E\u8FBC\uFF09"), /*#__PURE__*/_jsx("br", {}), "\u203B", /*#__PURE__*/_jsx(Link, {
                  href: routes.campaignWithBroadcast,
                  children: "\u5BFE\u8C61\u306E\u653E\u9001\u5546\u54C1"
                }), "\u3092\u3054\u5951\u7D04\u4E2D\u306E\u65B9\u306F".concat(course.trialText, "\u7D42\u4E86\u6642\u306B\u6708\u984D").concat(broadcastDiscountPrice, "\u5186(\u7A0E\u8FBC)")]
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "".concat(styles.info, " ").concat(styles.paymentMethod),
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u652F\u6255\u65B9\u6CD5"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: PAYMENT_METHOD_NAMES[paymentMethod]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u521D\u56DE\u6C7A\u6E08\u65E5"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: initialTransactionAt
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.attentionNote,
      children: /*#__PURE__*/_jsxs("p", {
        children: [!adultMode && /*#__PURE__*/_jsx(_Fragment, {
          children: "\u5F15\u304D\u7D9A\u304DSPOOX\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044"
        }), adultMode && /*#__PURE__*/_jsx(_Fragment, {
          children: "\u5F15\u304D\u7D9A\u304DSPOOX EX\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044"
        }), /*#__PURE__*/_jsx("br", {}), "\u672C\u5546\u54C1\u306F\u81EA\u52D5\u66F4\u65B0\u3068\u306A\u308A\u307E\u3059\u3002\u3054\u89E3\u7D04\u306E\u969B\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u3054\u5229\u7528\u72B6\u6CC1\u304B\u3089\u304A\u624B\u7D9A\u304D\u304F\u3060\u3055\u3044"]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.btnArea,
      children: /*#__PURE__*/_jsx(ButtonLink, {
        href: routes.channelDetail(course === null || course === void 0 ? void 0 : (_course$channel = course.channel) === null || _course$channel === void 0 ? void 0 : _course$channel.id),
        fillColor: true,
        large: true,
        fontFixed: true,
        children: "\u3055\u3063\u305D\u304F\u8996\u8074\u53EF\u80FD\u4F5C\u54C1\u3092\u30C1\u30A7\u30C3\u30AF\u3059\u308B"
      })
    }), broadcastDiscountFlag && !trialFlag && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("br", {}), "\u203B\u5272\u5F15\u6761\u4EF6\u306F", /*#__PURE__*/_jsx("span", {
        className: styles.discountLink,
        children: /*#__PURE__*/_jsx(Link, {
          href: routes.campaignWithBroadcast,
          children: "\u3053\u3061\u3089"
        })
      }), "\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"]
    })]
  });
}